document.addEventListener("DOMContentLoaded", function() {
    // Variablen für DOM-Elemente
    var ingredientsListDiv = document.querySelector(".ingredients-list.mv40");
    var minusButton = document.getElementById("minus");
    var plusButton = document.getElementById("plus");
    console.log("bin hier");
    var servingsDisplay = document.getElementById("servings");
  
    if (!ingredientsListDiv) {
      console.error("ingredients-list Div nicht gefunden.");
      return;
    }
  
    // Lese die data-ingredients Attribute aus
    var ingredientsData = ingredientsListDiv.getAttribute('data-ingredients');
  
    if (!ingredientsData) {
      console.error("Keine Zutaten-Daten gefunden.");
      return;
    }
  
    try {
      // Un-Escaping der JSON-Daten
      ingredientsData = ingredientsData.replace(/&quot;/g, '"');
      var data = JSON.parse(ingredientsData);
    } catch (e) {
      console.error("Fehler beim Parsen der Zutaten-Daten:", e);
      return;
    }
  
    // Extrahiere die Anzahl der Portionen und die Zutatenliste
    var initialServings = data.servings || 1;
    var currentServings = initialServings; // Aktuelle Anzahl der Portionen
    var ingredients = data.ingredients || [];
  
    // Speichere die Originalzutaten für die Neuberechnung
    var originalIngredients = JSON.parse(JSON.stringify(ingredients));
  
    // Funktion zur Umwandlung von Dezimalzahlen in Brüche
    function decimalToFraction(amount) {
      const fractionMap = {
        0.125: "⅛",
        0.166: "⅙",
        0.2: "⅕",
        0.25: "¼",
        0.333: "⅓",
        0.375: "⅜",
        0.4: "⅖",
        0.5: "½",
        0.6: "⅗",
        0.666: "⅔",
        0.75: "¾",
        0.8: "⅘",
        0.833: "⅚",
        0.875: "⅝",
        0.9: "⅞"
      };
  
      // Prüfen, ob der Betrag eine ganze Zahl ist
      if (Number.isInteger(amount)) {
        return `${amount}`;
      }
  
      // Runden auf drei Dezimalstellen zur besseren Vergleichbarkeit
      let rounded = Math.round(amount * 1000) / 1000;
  
      let wholeNumber = Math.floor(rounded);
      let decimalPart = rounded - wholeNumber;
  
      // Finden des nächstgelegenen Bruchs
      let closestFraction = "";
      let minDifference = Infinity;
  
      for (let key in fractionMap) {
        let frac = parseFloat(key);
        let difference = Math.abs(decimalPart - frac);
        if (difference < minDifference) {
          minDifference = difference;
          closestFraction = fractionMap[key];
        }
      }
  
      // Akzeptiere nur Brüche mit einer Differenz von maximal 0.05
      if (minDifference <= 0.05 && closestFraction !== "") {
        if (wholeNumber > 0) {
          return `${wholeNumber} ${closestFraction}`;
        } else {
          return `${closestFraction}`;
        }
      } else {
        // Wenn kein passender Bruch gefunden wurde, zeige die Zahl mit zwei Dezimalstellen
        return rounded.toFixed(2);
      }
    }
  
    // Funktion zur Aktualisierung der Zutatenanzeige
    function updateIngredientsDisplay() {
      var emptyPlaceholder = "&nbsp;";
      var ingredientsList = '';
  
      originalIngredients.forEach(function(item) {
        let amountDisplay = emptyPlaceholder;
  
        if (item.amount && item.unit) {
          // Berechne die neue Menge basierend auf der aktuellen Portionszahl
          let adjustedAmount = (item.amount / initialServings) * currentServings;
          adjustedAmount = Math.round(adjustedAmount * 1000) / 1000; // Runden auf 3 Dezimalstellen
          amountDisplay = decimalToFraction(adjustedAmount) + ' ' + item.unit;
        } else if (item.amount && !item.unit) {
          // Nur Menge ohne Einheit
          let adjustedAmount = (item.amount / initialServings) * currentServings;
          adjustedAmount = Math.round(adjustedAmount * 1000) / 1000;
          amountDisplay = decimalToFraction(adjustedAmount);
        }
  
        ingredientsList += `
          <div class="row">
            <div class="ingred am">${amountDisplay}</div>
            <div class="ingred name">${item.ingredient}</div>
          </div>`;
      });
  
      // Aktualisiere die Zutatenliste im DOM
      ingredientsListDiv.innerHTML = ingredientsList;
    }
  
    // Funktion zur Aktualisierung der Portionsanzeige
    function updateServingsDisplay() {
      servingsDisplay.textContent = currentServings + ' Portion' + (currentServings === 1 ? '' : 'en');
    }
  
    // Event Listener für den Plus-Button
    plusButton.addEventListener('click', function() {
      currentServings++;
      updateServingsDisplay();
      updateIngredientsDisplay();
    });
  
    // Event Listener für den Minus-Button
    minusButton.addEventListener('click', function() {
      if (currentServings > 1) {
        currentServings--;
        updateServingsDisplay();
        updateIngredientsDisplay();
      }
    });
  
    // Initiale Anzeige aktualisieren
    updateServingsDisplay();
    updateIngredientsDisplay();
  });
  